module.exports = __webpack_public_path__ + "static/img/春聚會館.a1269cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/春聚會館.png?20181011
// module id = Kxgj
// module chunks = 1